import React from 'react';
import '../../Cards.css';
import CardItem from '../../CardItem';

export default function ProjectHome() {
    return ( 
        <div className='cards'>
        <h1>Sift through my Projects!</h1>
        <div className='cards__container'>
            <div className='cards__wrapper'>
            <ul className='cards__items'>
                <CardItem
                src='images/img-TheLabyrinth.jpg'
                text='Explore the labyrinth that is my first 3D game!'
                label='The Labyrinth'
                path='/DigitalPortfolio/projects/Labyrinth'
                />
                <CardItem
                src='images/img-models.png'
                text='Take a look at an application I made to display my animated models!'
                label='Models'
                path='/DigitalPortfolio/projects/Models'
                />
                <CardItem
                src='images/img-checkers.jpg'
                text='Experience the second React app I have made!'
                label='Checkers'
                path='/DigitalPortfolio/projects/Checkers'
                />
            </ul>
            <ul className='cards__items'>
                <CardItem
                src='images/img-ProjectRTSS.jpg'
                text='Journey through the unfinished group project of Project RTSS'
                label='ProjectRTSS'
                path='/DigitalPortfolio/projects/ProjectRTSS'
                />
                <CardItem
                src='images/img-salesforce.jpg'
                text='Checkout the application I have made to make my job run more effecient!'
                label='SalesForce'
                path='/DigitalPortfolio/projects/SalesForce'
                />
                <CardItem
                src='images/img-sql-gui.jpg'
                text='Go over the application I made that saved me time running common SQL querries!'
                label='SQL-GUI'
                path='/DigitalPortfolio/projects/SQL-GUI'
                />
                <CardItem
                src='images/img-tictactoe.jpg'
                text='Enjoy the first React project I developed in its simplicity!'
                label='TicTacToe'
                path='/DigitalPortfolio/projects/TicTacToe'
                />
            </ul>
            </div>
        </div>
        </div>
        )
}